<template>
  <div>
    <b-alert
      variant="info"
      show
      class="mb-3"
    >
      <div class="alert-body d-flex align-items-start">
        <feather-icon
          icon="InfoIcon"
          class="mr-50 flex-shrink-0"
          style="margin-top: 2px;"
        />
        <span>
          <strong>Event Management</strong> controls how shipment events work in your system.
          <ul class="mb-0 mt-1 pl-3">
            <li><strong>Event Workflow</strong> defines which events happen and in what order</li>
            <li>
              <strong>Related:</strong> Visit the <strong>Notifications</strong> tab above to configure which events trigger external notifications
            </li>
          </ul>
        </span>
      </div>
    </b-alert>

    <b-card class="mb-2 shadow-sm">
      <b-card-title class="mb-0 pb-0">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <feather-icon
              icon="GitBranchIcon"
              size="20"
              class="mr-75 text-primary"
            />
            <h4 class="mb-0 font-weight-bolder">
              Event Workflow
            </h4>
          </div>
          <b-badge
            variant="light-secondary"
            class="text-uppercase"
          >
            Step 1
          </b-badge>
        </div>
      </b-card-title>
      <b-card-text class="pt-1">
        <p class="text-muted mb-2">
          <strong>Define your shipment journey:</strong> Create custom events (e.g., "Package Sorted", "Ready for Pickup") and set the order they must happen in.
          You can require certain events to happen before others (prerequisites).
        </p>
        <hr class="my-2">
        <event-workflow-manager
          :company-id="companyId"
          @events-updated="handleEventsUpdated"
        />
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardText,
  BAlert,
  BBadge,
} from 'bootstrap-vue'
import EventWorkflowManager from '@/views/company/components/EventWorkflowManager.vue'

export default {
  name: 'EventManagement',
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BAlert,
    BBadge,
    EventWorkflowManager,
  },
  props: {
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  watch: {
    companyId() {
      this.$nextTick(() => {
        if (this.$refs.eventMappingsList && typeof this.$refs.eventMappingsList.fetchAvailableTypes === 'function') {
          this.$refs.eventMappingsList.fetchAvailableTypes()
        }
      })
    },
  },
  methods: {
    handleEventsUpdated() {
      if (this.$refs.eventMappingsList && typeof this.$refs.eventMappingsList.fetchAvailableTypes === 'function') {
        this.$refs.eventMappingsList.fetchAvailableTypes()
      }
    },
  },
}
</script>

<style scoped>
.card-title h4 {
  font-weight: 600;
}
</style>
